export default __webpack_public_path__ + "static/O0165-22b13191ccc65ed872158f7925466ff9.png";